export default "__VITE_ASSET__Bqa87CiJ__"